/**
 * Header bag count.
 *
 * Mirrors the `span.niamito-cart-count` fragment (inc/cart-count.php) onto the
 * header bag badge after an AJAX cart change.
 *
 * The badge is drawn by CSS as `.icon--cart::after` with
 * `content: attr(data-cart-qty)`, and is force-hidden unless the body carries
 * `cart-not-empty` — which is set server-side at page load only. So both the
 * attribute and that class have to be updated here, or the number silently
 * stays at its page-load value (or never appears at all, going from an empty
 * cart to a full one).
 *
 * Deliberately not guarded on the side cart drawer: the count has to keep
 * working when `enable_custom_side_cart` is off and the tooltip
 * (inc/cart-tooltip.php) is the confirmation UI instead.
 */

// Wrapped in a block so the jQuery alias stays local: these modules are
// concatenated without import/export, so a top-level `const $` would collide
// with the one in singleProductAddToCart.ts.
{
  const $ = (window as any).jQuery;

  const syncCartCount = (): void => {
    // Any of the carriers will do — desktop and mobile hold the same number, and
    // WooCommerce replaces both with the same fragment.
    const carrier = document.querySelector<HTMLElement>(".niamito-cart-count");
    if (!carrier) return;

    const count = carrier.getAttribute("data-cart-count") ?? "0";

    document
      .querySelectorAll<HTMLElement>(".icon--cart")
      .forEach((el) => el.setAttribute("data-cart-qty", count));

    document.body.classList.toggle("cart-not-empty", parseInt(count, 10) > 0);
  };

  if ($) {
    // `added_to_cart` is WooCommerce's own (archive/loop AJAX); the namespaced
    // one comes from singleProductAddToCart.ts, which avoids core's event so
    // core does not append its "View cart" link beside the button. The refresh
    // events cover removals and cross-tab syncing.
    $(document.body).on(
      "added_to_cart niamito_added_to_cart wc_fragments_refreshed wc_fragments_loaded",
      syncCartCount
    );
  }

  // Initial sync: fragments may have been applied from the session cache before
  // this script ran, leaving the carrier ahead of the server-rendered badge.
  syncCartCount();
}
